import { useEffect } from 'react';
import { usePropertyZipTimezone } from '../hooks/usePropertyZipTimezone';

function TimezoneWatcher() {
  usePropertyZipTimezone();
  return null;
}

export default TimezoneWatcher;
